import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { validateEmailShareLink } from "../../Redux/ActionCreators/candidateAction";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import CandidateProfileV2 from "../candidateProfileV2/candidateProfileV2";

const SharedReportEmail = () => {
  const { emailToken } = useParams();
  const [code, setCode] = useState("");
  const [validating, setValidating] = useState(false);
  const [verified, setVerified] = useState(false);

  const [snack, setSnack] = useState({
    open: false,
    msg: "",
    severity: "error",
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (!verified) {
      localStorage.removeItem("share_access_token_copied");
      localStorage.removeItem("share_access_token_email");
      localStorage.removeItem("share_access_token_expiry");
      localStorage.removeItem("shared_job_id");
      localStorage.removeItem("shared_candidate_id");
    }
  }, [verified]);

  useEffect(() => {
    const token = localStorage.getItem("share_access_token_email");
    const expiry = localStorage.getItem("share_access_token_expiry");
    if (token && expiry && Date.now() < Number(expiry)) {
      const sj = localStorage.getItem("shared_job_id");
      const sc = localStorage.getItem("shared_candidate_id");
      if (sj && sc) setVerified(true);
    }
    function handleExpired() {
      setVerified(false);
    }
    window.addEventListener("shared-auth-expired", handleExpired);
    return () =>
      window.removeEventListener("shared-auth-expired", handleExpired);
  }, []);

  const handleSubmit = async () => {
    setValidating(true);

    const payload = {
      email_token: emailToken,
      access_code: code,
    };

    const res = await dispatch(validateEmailShareLink(payload));

    setValidating(false);

    if (res?.status === 403) {
      setSnack({
        open: true,
        msg: "Verification code is wrong, please try again",
        severity: "error",
      });
      return;
    }

    if (res?.success) {
      const jobId = res.data.job_id;
      const candidateId = res.data.job_candidate_id;
      const expiryTime = Date.now() + 3600 * 1000;

      localStorage.setItem("share_access_token_email", res.data.access_token);
      localStorage.setItem("share_access_token_expiry", String(expiryTime));
      localStorage.setItem("shared_job_id", jobId);
      localStorage.setItem("shared_candidate_id", candidateId);

      localStorage.setItem(
        "hide_candidate_details",
        res.data.hide_candidate_details ? "true" : "false"
      );

      setVerified(true);
    }
  };

  if (verified) {
    window.isSharedReportMode = true;
    return (
      <CandidateProfileV2
        isSharedReport={true}
        hideSensitive={localStorage.getItem("hide_candidate_details") === "true"}
        jobId={localStorage.getItem("shared_job_id")}
        candidateId={localStorage.getItem("shared_candidate_id")}
      />
    );
  }

  return (
    <div className="verification-container">
      <div className="verification-holder">
        <h2>Please enter your verification code</h2>

        <input
          type="text"
          placeholder="Enter access code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />

        <button onClick={handleSubmit} disabled={validating}>
          {validating ? "Verifying..." : "Submit"}
        </button>
      </div>

      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => setSnack({ ...snack, open: false })}
      >
        <Alert severity={snack.severity}>{snack.msg}</Alert>
      </Snackbar>
    </div>
  );
};

export default SharedReportEmail;
